import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoPopupComponent } from './components/video-popup.component';
import { CardModule } from 'studio-components/card/card.module';
import { ButtonLegacyModule } from 'studio-components/button-legacy/button-legacy.module';

const components = [VideoPopupComponent];

@NgModule({
  declarations: components,
  imports: [CommonModule, CardModule, ButtonLegacyModule],
  exports: components,
})
export class VideoPopupModule {}
